import type { TFunction } from 'i18next';

const EMPTY = '–';

/** "Form updated" -> "form_updated", the key under `security.history.events`. */
export function labelKey(label: string): string {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

/** The backend sends English labels; known ones are translated, others shown as sent. */
export function eventText(t: TFunction, label: string): string {
  return t(`security.history.events.${labelKey(label)}`, { defaultValue: label });
}

function termText(t: TFunction, term: string): string {
  return t(`security.history.terms.${labelKey(term)}`, { defaultValue: term });
}

export function methodText(t: TFunction, method: string | null | undefined): string {
  return method ? termText(t, method) : EMPTY;
}

/** The backend writes "—" when it has no place; the table uses one dash for every empty cell. */
export function placeText(location: string | null | undefined): string {
  const value = location?.trim();
  return value && value !== '—' && value !== '-' ? value : EMPTY;
}

/** "Chrome on Linux" -> "Chrome unter Linux"; browser and system names stay as they are. */
export function deviceText(t: TFunction, device: string | null | undefined): string {
  const value = device?.trim();
  if (!value) return EMPTY;
  const on = /^(.+) on (.+)$/.exec(value);
  if (on) return t('security.history.deviceOn', { browser: on[1], os: on[2] });
  return termText(t, value);
}
